import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import React, { useEffect, useState } from "react";

interface ILogInStatus {
    iconSize: string;
    color: string;
    className: string;
}

const LogInStatus: React.FC<ILogInStatus> = (props) => {
    const isLoggedIn = useSelector((state: RootState) => state.client.isLoggedIn);
    const [urlProtocol] = useState(useSelector((state: RootState) => state.config.urlProtocol));
    const currentUrl = window.location.href;

    const redirectToAccountsPage = () => {
        window.location.href = `${urlProtocol}://wilcz.com/accounts?continue=${encodeURIComponent(currentUrl)}`;
    };

    return (
        <div className={props.className} onClick={redirectToAccountsPage}>
            {isLoggedIn ? (
                <i className="bi bi-person-check" style={{ fontSize: props.iconSize, color: props.color }}></i>
            ) : (
                <i className="bi bi-person" style={{ fontSize: props.iconSize, color: props.color }}></i>
            )}
        </div>
    );
};

export default LogInStatus;
